import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * Product Weight & Dimensions component.
 *
 * Listens for variant update events emitted by the variant picker and
 * swaps in the new server-rendered content for the matching block id.
 *
 * @extends {Component}
 */
class ProductWeightDimensions extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  /**
   * @param {Event} event - The variant update event.
   */
  update = (event) => {
    /** @type {any} */
    const variantEvent = event;
    const detail = variantEvent.detail;
    if (!detail?.data?.html) return;

    if (detail.data.newProduct) {
      this.dataset.productId = detail.data.newProduct.id;
    } else if (
      variantEvent.target instanceof HTMLElement &&
      variantEvent.target.dataset.productId &&
      variantEvent.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newEl = detail.data.html.querySelector(
      `product-weight-dimensions[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newEl) return;

    const fragment = document.createDocumentFragment();
    Array.from(newEl.cloneNode(true).childNodes).forEach((node) => fragment.appendChild(node));
    this.replaceChildren(fragment);
  };
}

if (!customElements.get('product-weight-dimensions')) {
  customElements.define('product-weight-dimensions', ProductWeightDimensions);
}
